/**
 * Helper function to get current filter value from filter expressions
 * @param filterValues Array of filter objects with key and value expression
 * @param fieldName The field name to search for
 * @returns The extracted value or empty string if not found
 */
export const getCurrentFilterValue = (
  filterValues: { key: string; value: string }[],
  fieldName: string
): string => {
  if (!fieldName) return '';

  const filter = filterValues.find(f => f.key === fieldName);
  if (!filter) return '';

  const valueMatch = filter.value.match(/\.(eq|gt|gte|lt|lte|like)\((.*?)\)$/);
  if (valueMatch && valueMatch[2]) {
    const operator = valueMatch[1];
    // For operator-specific keys (e.g., DATE.gte), return the extracted value
    if (filter.key.includes('.') || operator === 'eq') {
      return valueMatch[2].replace(/^["']|["']$/g, '');
    }
  }

  return filter.value;
};
